import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Assets from './pages/Assets';
import Leases from './pages/Leases';
import Payments from './pages/Payments';
import Maintenance from './pages/Maintenance';
import Reports from './pages/Reports';
import AIDashboard from './pages/AIDashboard';
import SMSDashboard from './pages/SMSDashboard';
import AssetPaymentOverview from './pages/AssetPaymentOverview';
import Settings from './pages/Settings';
import TenantManagement from './pages/TenantManagement';
import SuperAdminTenants from './pages/SuperAdminTenants';
import TenantPortal from './pages/TenantPortal';
import ChatPage from './pages/ChatPage';
import UnattributedPayments from './pages/UnattributedPayments';
import BulkImport from './pages/BulkImport';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/Layout/ProtectedRoute';

function App() {
    const { user, isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    return (
        <Router>
            <Routes>
                <Route path="/login" element={
                    isAuthenticated ? <Navigate to={user?.role === 'tenant' ? '/portal' : '/dashboard'} /> : <Login />
                } />
                
                {/* Reset Password - public route, accessed via email link */}
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                
                {/* Tenant Portal - full screen, no layout wrapper */}
                <Route path="/portal/*" element={
                    <ProtectedRoute allowedRoles={['tenant']}>
                        <TenantPortal />
                    </ProtectedRoute>
                } />

                <Route element={<ProtectedRoute allowedRoles={['superadmin', 'landlord', 'caretaker']} />}>
                    <Route element={<Layout />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/assets" element={<Assets />} />
                        <Route path="/leases" element={<Leases />} />
                        <Route path="/payments" element={<Payments />} />
                        <Route path="/payments/overview" element={<AssetPaymentOverview />} />
                        <Route path="/payments/unattributed" element={<UnattributedPayments />} />
                        <Route path="/maintenance" element={<Maintenance />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/tenants" element={<TenantManagement />} />
                        <Route path="/superadmin" element={<SuperAdminTenants />} />
                        <Route path="/ai" element={<AIDashboard />} />
                        <Route path="/sms" element={<SMSDashboard />} />
                        <Route path="/chat" element={<ChatPage />} />
                        <Route path="/bulk-import" element={<BulkImport />} />

                        <Route path="/" element={<Navigate to="/dashboard" />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    );

}

export default App;
